<template>
  <div id="passwordValidator" class="grid gap-3 text-sm font-medium mt-6 mb-2" :class="gridColClasses">
    <div v-for="(check, key) in checks" :key="key">
      <div class="flex gap-2 items-center justify-start" :class="!passwordChecks[key] && 'opacity-50'">
        <div class="w-4 h-4 relative">
          <TransitionRotate>
            <HandThumbUpIconSolid v-if="passwordChecks[key]" class="absolute inset-0 w-4 h-4 text-emerald-600" :style="hexStyle"/>
          </TransitionRotate>
          <TransitionRotate>
            <HandThumbUpIcon  v-if="!passwordChecks[key]" class="absolute inset-0 w-4 h-4 text-red-300 rotate-180" :style="hexStyle"/>
          </TransitionRotate>
        </div>
        {{ check.label }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, watch } from "vue";
import { HandThumbUpIcon } from "@heroicons/vue/24/outline";
import { HandThumbUpIcon as HandThumbUpIconSolid } from "@heroicons/vue/24/solid";
import TransitionRotate from "./TransitionRotate.vue";

const props = defineProps({
  password: {
    type: String,
    required: true,
  },
  passwordConfirmation: {
    type: String,
    required: true,
  },
  hex: {
    type: [String, Boolean],
    default: false,
  },
  gridColClasses: {
    type: String,
    default: "grid-cols-2 lg:grid-cols-3"
  },
});

const passwordChecks = reactive({
  length: false,
  lowercase: false,
  uppercase: false,
  number: false,
  special: false,
  match: false,
});

const checks = {
  length: { label: "8 characters" },
  special: { label: "1 special character" },
  lowercase: { label: "1 lowercase" },
  uppercase: { label: "1 uppercase" },
  number: { label: "1 number" },
  match: { label: "Matching" },
};

const hexStyle = computed(() => (props.hex ? `color:${props.hex}` : ""));

function updatePasswordChecks() {
  passwordChecks.length = props.password.length > 7;
  passwordChecks.lowercase = /[a-z]/.test(props.password);
  passwordChecks.uppercase = /[A-Z]/.test(props.password);
  passwordChecks.number = /\d/.test(props.password);
  passwordChecks.special = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(props.password);
  passwordChecks.match = props.password && props.password === props.passwordConfirmation;
}

watch(() => props.password, updatePasswordChecks, { immediate: true });
watch(() => props.passwordConfirmation, updatePasswordChecks, { immediate: true });
</script>
